var paramGet = require('./paramGet.js');

function init( param ) {
    var paramVal = $.urlParam(param);

    if ( paramVal ) {
        // console.log('cookieSet | ' + param + ': ' + paramVal.trim() );
        document.cookie = param + "=" + unescape( paramVal.trim() ) + ';path=/';
    }
}

module.exports = { init };